module.exports = __webpack_public_path__ + "static/media/mainTopicBlue.7ac37906.svg";